import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import logo from "../../assets/images/dashboardLogo.png";
import backButton from "../../assets/images/arrow_back.png";
import backgroundImage from "../../assets/images/chatBackground.png";
import loader from "../../assets/images/spinnee.gif";
import axios from "axios";
import {
  Grid,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import {
  ToastContainer,
  toast,
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PdfPreview from "../../components/preview/Preview";
import HeaderProfile from "../../components/profile/ProfileHeader";
import {
  fetchBinderSelection,
  fetchCountry,
  fetchLook,
  fetchProduct,
  fetchRegiObjective,
} from "../../store/apiActions";
import { useDispatch, useSelector } from "react-redux";
import { encrypted } from "../../utils/Utility";
import { fetchVerifyToken } from "../../store/apiActions";
import { env } from "../../environment.template";

function Dashboard() {
  const [pdfUrl, setPdfUrl] = useState("");
  useEffect(() => {
    let data = localStorage.getItem("isLogin");
    if (data) {
      toast.success("You are successfully logged in");
      localStorage.removeItem("isLogin");
    }
  }, []);

  // Handle input change
  const [formData, setFormData] = useState({
    country: "",
    productName: "",
    technicalMaterial: "",
    registration: "",
    formulation: "",
    binderSelection: "",
  });

  const [countries, setCountries] = useState([]);
  const [product, setProduct] = useState([]);
  const [regiObject, setRegiObject] = useState([]);
  const [binder, setBinder] = useState([]);

  // API structure
  const dispatch = useDispatch();
  const countryResponse = useSelector((state) => state?.api?.countryDetails);
  const productResponse = useSelector((state) => state?.api?.productDetails);
  const regiObjectiveResponse = useSelector((state) => state?.api?.regiObjectiveDetails);
  const binderResponse = useSelector((state) => state?.api?.binderSelectionDetails);
  const lookResponse = useSelector((state) => state?.api?.lookDetails);
  const [generateReport, setGenerateReport] = useState(false);
  const [generateLoader, setGenerateLoader] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);
  const loggedInDetails = localStorage.getItem("LoggedInDetails");
  const formatDate = (dateString) => {
    const date = new Date(dateString);
  
    if (isNaN(date.getTime())) {
      return '---';
    }
  
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  };
  
  const [lookData, setLookData] = useState([
    {
      regulatory_process: " -- ",
      recipe_code: " -- ",
      brand_names_registered: " -- ",
      submission_date: " -- ",
    },
  ]);

  // Country Response
  useEffect(() => {
    if (countryResponse?.data) {
      const mappedCountries = countryResponse.data.map((item) => ({
        code: item.country_name,
        name: item.country_name,
      }));
      setCountries(mappedCountries);
    }
  }, [countryResponse?.data]);

  useEffect(() => {
    if (productResponse?.data) {
      const excludedProducts = [
        "acetamiprid_methoxyfenozide_150_240_wg",
        "acifluorfen_clodinafop_propargyl_165_80_ec",
        "propanil_triclopyr_butotyl_380_55_6_ec",
      ];
      const mappedProduct = productResponse.data
        .filter(
          (item) => !excludedProducts.includes(item.formulation_name_clean)
        )
        .map((item) => ({
          code: item.formulation_name_clean,
          name: item.formulation_name_clean,
        }));
      setProduct(mappedProduct);
    }
  }, [productResponse?.data]);

  // Registration Objective Response
  useEffect(() => {
    if (regiObjectiveResponse?.data) {
      const mappedRegi = regiObjectiveResponse.data.map((item) => ({
        code: item.registration_objective,
        name: item.registration_objective,
      }));
      setRegiObject(mappedRegi);
    }
  }, [regiObjectiveResponse?.data]);

  useEffect(() => {
    if (binderResponse?.data) {
      // Binder to exclude
      // const excludedBinder = "242354_regds_000000028_ng_reg_ng_104_001";
      // Filter out unwanted binder
      const mappedBinder = binderResponse.data
        .filter((item) => item?.binder_id_name) // Remove specific binder
        .map((item) => ({
          code: item?.binder_id_name || "",
          name: item?.binder_id_name || "",
        }));

      setBinder(mappedBinder);
    }
  }, [binderResponse?.data]);

  useEffect(() => {
    setLookData(lookResponse?.data?.[0]);
  }, [lookResponse]);

  // Country API Integration
  useEffect(() => {
    setCountries([]);
    setProduct([]);
    setRegiObject([]);
    setBinder([]);
    setLookData([
      {
        regulatory_process: " -- ",
        recipe_code: " -- ",
        brand_names_registered: " -- ",
        submission_date: " -- ",
      },
    ]);
    dispatch(fetchCountry(`${env.baseURL}/get_country_name`));
  }, [dispatch]);

  // Product API Integration
  useEffect(() => {
    if (formData?.country?.trim()) {
      try {
        let requestBody = {
          country: formData.country,
        };
        setProduct([]);
        setRegiObject([]);
        setBinder([]);
        setLookData([
          {
            regulatory_process: " -- ",
            recipe_code: " -- ",
            brand_names_registered: " -- ",
            submission_date: " -- ",
          },
        ]);
        dispatch(
          fetchProduct(`${env.baseURL}/formulation_name_clean`, {
            encryptedBody: encrypted.encrypt(JSON.stringify(requestBody)),
          })
        );
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    }
  }, [formData?.country, dispatch]);

  // Registration Objective API Integration
  useEffect(() => {
    if (formData?.productName !== "") {
      let requestBody = {
        country: formData.country,
        formulation_name_clean: formData.productName,
      };
      setLookData([
        {
          regulatory_process: " -- ",
          recipe_code: " -- ",
          brand_names_registered: " -- ",
          submission_date: " -- ",
        },
      ]);
      setRegiObject([]);
      setBinder([]);
      dispatch(
        fetchRegiObjective(`${env.baseURL}/registration_objective`, {
          encryptedBody: encrypted.encrypt(JSON.stringify(requestBody)),
        })
      );
    }
  }, [formData.productName, dispatch]);

  // Binder Selection API Integration
  useEffect(() => {
    if (formData?.registration !== "") {
      let requestBody = {
        registration_objective: formData.registration,
      };
      dispatch(
        fetchLook(`${env.baseURL}/lookup`, {
          encryptedBody: encrypted.encrypt(JSON.stringify(requestBody)),
        })
      );
    }
  }, [formData.registration, dispatch]);

  // Binder Selection API Integration
  useEffect(() => {
    if (formData?.registration !== "") {
      let requestBody = {
        registration_objective: formData.registration,
      };
      setBinder([]);
      dispatch(
        fetchBinderSelection(`${env.baseURL}/binder_id`, {
          encryptedBody: encrypted.encrypt(JSON.stringify(requestBody)),
        })
      );
    }
  }, [formData.registration, dispatch]);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      let updatedData = { ...prevData, [name]: value };

      if (name === "country") {
        updatedData = {
          ...updatedData,
          productName: "",
          registration: "",
          binderSelection: "",
        };
        setProduct([]);
        setRegiObject([]);
        setBinder([]);
      } else if (name === "productName") {
        updatedData = {
          ...updatedData,
          registration: "",
          binderSelection: "",
        };
        setRegiObject([]);
        setBinder([]);
      } else if (name === "registration") {
        updatedData = {
          ...updatedData,
          binderSelection: "",
        };
        setBinder([]);
      }

      return updatedData;
    });
  };
  
  const handleDownloadDocs = async () => {
    let requestBody = {
      country: formData.country,
      formulation_name_clean: formData.productName,
      registration_objective: formData.registration,
      binder_id_name: formData.binderSelection,
    };
    let token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${env.baseURL}/download_dossier`,
        {
          encryptedBody: encrypted.encrypt(JSON.stringify(requestBody)),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );
      const file = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      const today = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
      const date = new Date(today);
      const options = { month: "short", day: "2-digit", year: "numeric" };
      const formattedDate = date.toLocaleDateString("en-US", options)
        .replace(" ", "-")
        .replace(", ", "-");
      a.download = `${formData.country}_${formData.productName}_${formattedDate}.docx`;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error generating DOCX:", error);
      toast.error("Failed to generate DOCX. Please try again later.");
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    let requestBody = {
      country: formData.country,
      formulation_name_clean: formData.productName,
      registration_objective: formData.registration,
      binder_id_name: formData.binderSelection,
    };
    setGenerateLoader(true);
    let token = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${env.baseURL}/generate_dossier`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        encryptedBody: encrypted.encrypt(JSON.stringify(requestBody)),
      },
      responseType: "arraybuffer",
    };

    axios(config)
      .then((response) => {
        setGenerateLoader(false);
        setGenerateReport(true);
        setFormDisabled(true);
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfUrl(fileURL);
      })
      .catch((error) => {
        setGenerateReport(false);
        setGenerateLoader(false);
        const decoder = new TextDecoder('utf-8');
        const text = (decoder.decode(new Uint8Array( error?.response?.data)));
        const errorReponse=JSON.parse(text)
        const decryptedData = encrypted.decrypt(errorReponse?.encryptedBody);
        const newError = JSON.parse(decryptedData);
        toast.error(newError?.message);
      });
  };

  // Custom download handler to rename the PDF
  const handleDownload = () => {
    if (pdfUrl) {
        const link = document.createElement("a");
        link.href = pdfUrl;
        const today = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
        const date = new Date(today);
        const options = { month: "long", day: "2-digit", year: "numeric" };
        const formattedDate = date.toLocaleDateString("en-US", options)
        .replace(" ", "-")
        .replace(", ", "-");
        link.download = `${formData.country}_${formData.productName}_${formattedDate}.pdf`;  
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

  const verifyResponse = useSelector((state) => state?.api?.verifyTokenDetails);
  useEffect(() => {
    dispatch(fetchVerifyToken(`${env.baseURL}/auth/azure/verify-token`));
  }, [dispatch]);

  useEffect(() => {
      if (verifyResponse?.data?.message === "Token invalid") {
        handleLogout();
    }
  }, [verifyResponse]);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token"); // Retrieve token
      const response = await fetch(`${env.baseURL}/app-users/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include auth token
        },
      });
      if (response.ok) {
        toast.success("Logout successful!");
      } else {
        toast.success("Logout successful!");
      }
    } catch (error) {
      toast.success("Logout successful!");
    }

    localStorage.clear();
    window.location.href = "/sign-in";
  };

  const handleBack = () => {
    setGenerateReport(false);
    setFormDisabled(false);
    setGenerateLoader(false);
  };

  const isFormValid = () => {
    return (
      formData.country &&
      formData.productName &&
      formData.registration &&
      formData.binderSelection
    );
  };

  const [isSidebarMinimized, setIsSidebarMinimized] = useState(() => {
    const saved = localStorage.getItem("sidebarMinimized");
    return saved === "true";
  });

  const handleToggleMinimize = (isMinimized) => {
    setIsSidebarMinimized(isMinimized);
  };

  return (
    <>
      <ToastContainer closeButton={true} position="bottom-right" />
      <div
        className="dashboard-container"
        style={{
          height: "100%",
          overflow: "hidden",
          display: "grid",
          gridTemplateColumns: isSidebarMinimized ? "6% 92%" : "20% 80%",
        }}
      >
        <Sidebar onToggleMinimize={handleToggleMinimize} />
        <div
          style={{
            height: "100%",
            overflowY: "auto",
            padding: "5px",
            marginRight: "2%",
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="header-container-dashboard">
              <HeaderProfile loggedInDetails={loggedInDetails} />
            </div>

            {!generateReport && !generateLoader && !formDisabled && (
              <div className="dashboard-prompt-logo">
                <img src={logo} alt="" />
              </div>
            )}
            <Typography
              variant="h5"
              color="#121417"
              fontSize={25}
              margin={0}
              marginBottom={2}
              fontWeight={600}
              gutterBottom
            >
              <span className="back-dashboard-title">
                {generateReport && (
                  <span onClick={handleBack} className="back-button">
                    <img src={backButton} alt="Back" />
                  </span>
                )}
                {generateReport ? "Dossier" : "Generate a Dossier"}
              </span>
            </Typography>
            {!generateReport && (
              <div className="dashboard-sub-title">
                Making the community's best AI chat models available for
                everyone
              </div>
            )}

            <div className="form-container">
              <Grid container spacing={3}>
                {/* Country */}
                <Grid
                  item
                  xs={12}
                  sm={3}
                  sx={{
                    paddingTop: "5px !important",
                  }}
                >
                  <FormControl
                    fullWidth
                    margin="normal"
                    required
                    sx={getDropdownStyles()}
                    disabled={formDisabled || generateLoader}
                  >
                    <InputLabel required>Country</InputLabel>
                    <Select
                      name="country"
                      value={formData.country || ""}
                      onChange={(e) =>
                        handleInputChange({
                          target: { name: "country", value: e.target.value },
                        })
                      }
                      sx={{
                        fontSize: "13px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "transparent",
                        },
                        "& .MuiInputBase-input": {
                          cursor: formDisabled || generateLoader? "not-allowed" : "pointer",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            width: "10%",
                            maxHeight: 300,
                          },
                        },
                      }}
                    >
                      {countryResponse.loading ? (
                        <MenuItem disabled value="">
                          Loading...
                        </MenuItem>
                      ) : countries.length > 0 ? (
                        countries.map((country) => (
                          <MenuItem
                            key={country.code}
                            value={country.code}
                            sx={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              display: "block",
                              fontSize: "14px",
                            }}
                          >
                            {toCamelCase(country.name)}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled value="">
                          No Countries Available
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Product */}
                <Grid
                  item
                  xs={12}
                  sm={3}
                  sx={{
                    paddingTop: "5px !important",
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={getDropdownStyles()}
                    margin="normal"
                    required
                    disabled={formDisabled || generateLoader}
                  >
                    <InputLabel>Product</InputLabel>
                    <Select
                      sx={{
                        fontSize: "13px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "transparent",
                        },
                        "& .MuiInputBase-input": {
                          cursor: formDisabled || generateLoader ? "not-allowed" : "pointer",
                        },
                      }}
                      name="productName"
                      value={formData.productName || ""}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: "productName",
                            value: e.target.value,
                          },
                        })
                      }
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            width: "10%",
                            maxHeight: 300,
                          },
                        },
                      }}
                    >
                      {productResponse.loading ? (
                        <MenuItem disabled value="">
                          Loading...
                        </MenuItem>
                      ) : product.length > 0 ? (
                        product.map((material) => (
                          <MenuItem
                            key={material.code}
                            value={material.code}
                            sx={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              display: "block",
                              fontSize: "14px",
                            }}
                          >
                            {toCamelCase(material.name)}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled value="">
                          No Product Available
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Formulation */}
                <Grid
                  item
                  xs={12}
                  sm={3}
                  sx={{
                    paddingTop: "5px !important",
                  }}
                >
                  <FormControl
                    fullWidth
                    margin="normal"
                    required
                    disabled={formDisabled || generateLoader}
                    sx={getDropdownStyles()}
                  >
                    <InputLabel>Registration Objective</InputLabel>
                    <Select
                      name="registration"
                      value={formData.registration || ""}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: "registration",
                            value: e.target.value,
                          },
                        })
                      }
                      sx={{
                        fontSize: "13px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "transparent",
                        },
                        "& .MuiInputBase-input": {
                          cursor: formDisabled || generateLoader ? "not-allowed" : "pointer",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            width: "10%",
                            maxHeight: 300,
                          },
                        },
                      }}
                    >
                      {regiObjectiveResponse.loading ? (
                        <MenuItem disabled value="">
                          Loading...
                        </MenuItem>
                      ) : regiObject.length > 0 ? (
                        regiObject.map((formulation) => (
                          <MenuItem
                            key={formulation.code}
                            value={formulation.code}
                            sx={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              display: "block",
                              fontSize: "14px",
                            }}
                          >
                            {toCamelCase(formulation.name)}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled value="">
                          No Registration Objective Available
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Binder Selection */}
                <Grid
                  item
                  xs={12}
                  sm={3}
                  sx={{
                    paddingTop: "5px !important",
                  }}
                >
                  <FormControl
                    fullWidth
                    margin="normal"
                    required
                    sx={getDropdownStyles()}
                    disabled={formDisabled || generateLoader}
                  >
                    <InputLabel>Binder Selection</InputLabel>
                    <Select
                      name="binderSelection"
                      value={formData.binderSelection || ""}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: "binderSelection",
                            value: e.target.value,
                          },
                        })
                      }
                      sx={{
                        fontSize: "13px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "transparent",
                        },
                        "& .MuiInputBase-input": {
                          cursor: formDisabled || generateLoader ? "not-allowed" : "pointer",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            width: "10%",
                            maxHeight: 300,
                          },
                        },
                      }}
                    >
                      {binderResponse.loading ? (
                        <MenuItem disabled value="">
                          Loading...
                        </MenuItem>
                      ) : binder.length > 0 ? (
                        binder.map((source) => (
                          <MenuItem
                            key={source.code}
                            value={source.code}
                            sx={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              display: "block",
                              fontSize: "14px",
                            }}
                          >
                            {toCamelCase(source.name)}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled value="">
                          No Binder Selection Available
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                {/* Registration Objective */}
                {!generateReport && !formDisabled && (
                  <Grid item xs={12} style={{paddingTop:"0px"}}>
                    <Typography
                      variant="h6"
                      fontWeight={600}
                      gutterBottom
                      color="rgba(48, 48, 48, 1)"
                      fontSize={16}
                    >
                      Registration Objective
                    </Typography>
                    <ul
                      style={{
                        color: "rgba(48, 48, 48, 1)",
                        fontSize: "14px",
                        lineHeight: "31px",
                        margin:"0px",
                      }}
                    >
                      <li>
                        Regulatory Process:{" "}
                        {lookResponse.loading === true ? (
                          "Loading..."
                        ) : (
                          <>{lookData?.regulatory_process || " -- "}</>
                        )}
                      </li>
                      <li>
                        Recipe Code:{" "}
                        {lookResponse.loading === true ? (
                          "Loading..."
                        ) : (
                          <>{lookData?.recipe_code || " -- "}</>
                        )}
                      </li>
                      <li>
                        Brand Names:{" "}
                        {lookResponse.loading === true ? (
                          "Loading..."
                        ) : (
                          <>{lookData?.bxrand_names_registered || " -- "}</>
                        )}
                      </li>
                      <li>
                        Submission Date:{" "}
                        {lookResponse.loading === true ? (
                          "Loading..."
                        ) : (
                          <>{formatDate(lookData?.submission_date) || " -- "}</>
                        )}
                      </li>
                      <li>
                         Last modified binder date:{" "}
                        {lookResponse.loading === true ? (
                          "Loading..."
                        ) : (
                          <>{formatDate(lookData?.binder_version_modified_date) || " -- "}</>
                        )}
                      </li>
                    </ul>
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  sm={3}
                  sx={{
                    paddingTop: "5px !important",
                  }}
                  style={{ display: "grid", alignItems: "center" }}
                >
                  <Box>
                    {!generateReport && !formDisabled ? (
                      <button
                        className="dashboard-generate-report"
                        onClick={handleSubmit}
                        disabled={!isFormValid() || generateLoader}
                      >
                       {generateLoader? 'Generating application':'Generate application'}
                      </button>
                    ) : (
                      <button
                        className="dashboard-generate-report"
                        onClick={() => {
                          handleDownloadDocs();
                        }}
                      >
                        Download in Editable Format
                      </button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </div>
          </div>
          {generateLoader ? (
            <div className="dashboard-preview-container">
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  marginTop: "4%",
                }}
              >
                <img height="100px" width="100px" src={loader} alt="" />
                <span>Generating your application</span>
              </div>
            </div>
          ) : (
            generateReport && (
              <div className="dashboard-preview-container">
                <PdfPreview fileUrl={pdfUrl}  handleDownload={handleDownload}/>
              </div>
            )
          )}
        </div>
        {/* <Footer /> */}
        <div className="copyright-label">
          © 2025DossierGenAI. All Rights Reserved.
        </div>
      </div>
    </>
  );
}

export default Dashboard;

const getDropdownStyles = () => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FFF", // Background color
    borderRadius: "8px", // Border radius
    "& fieldset": {
      borderColor: "#6B737A", // Border color when not focused
    },
    "&:hover fieldset": {
      borderColor: "#6B737A", // Hover border color
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #6B737A", // Focused border color
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 12px", // Adjust padding to control the height
    fontSize: "14px", // Font size
    boxSizing: "border-box",
  },
  "& .MuiInputLabel-root": {
    backgroundColor: "#FFF",
    top: "10px", // Align label vertically a little higher
    left: "10px", // Align label to the left
    fontSize: "14px", // Font size
    transform: "translate(0, 0)", // Keep label up a little by default
    "&.Mui-focused, &.MuiInputLabel-shrink": {
      top: "-6px", // Move label to the top when focused or item is selected
      transform: "translate(0, 0) scale(0.75)", // Shrink label when focused
    },
    "&.Mui-focused": {
      color: "#6B737A", // Focused label color
      fontSize: "14px", // Focused label font size
    },
    "& .MuiFormLabel-asterisk": {
      color: "red", // Change asterisk color to red
    },
  },
});

const toCamelCase = (str) => {
  if (!str || typeof str !== "string") {
    return "";
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toUpperCase();
};
